import React, { useState, useEffect } from 'react'
import "./Perfil.scss"
import { jwtDecode } from "jwt-decode"
import Avatar from "../../assets/img/avatar-3.jpg"
import Modal2FAPerfil from '../../components/Modales/2FA/Modal2FAPerfil'
import { Modal } from 'react-bootstrap'
import { Oval } from 'react-loader-spinner'

function Perfil() {
    const token = localStorage.getItem("token")
    const obj = jwtDecode(token)
    const user = obj.apirest.objeto

    const [error, setError] = useState(null)
    const [modalError, setModalError] = useState(false)
    const [areaSelected, setAreaSelected] = useState(null)

    // modal doble factor
    const [modal2fa, setModal2fa] = useState(false)
    const [mfaData, setMfaData] = useState(null);
    const [modalSuccess, setModalSuccess] = useState(false);

    const [loading, setLoading] = useState(false)

    const fetchAreas = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/index/areasView`,{
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    user: user
                })
            })
            const data = await res.json()
            if(data.status !== 0){
                setError(data.errorDetalle)
            } else {
                const obj = data.objeto.find((e) => e.id_area === user.idArea)
                setAreaSelected(obj)
            }
        } catch (error) {
            setError("Error: Conexión con backend.")
        }
    }

    useEffect(() => {
        if(user.puesto === 4 || user.puesto === 5){
            fetchAreas()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const showModal = async () => {
        try {
            setLoading(true)
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/user/2FA/create`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    idUser: user.id
                })
            })
            const data = await res.json()
            if(data.status !== 0){
                setLoading(false)
                setError(data.errorDetalle || data.codeError)
                setModalError(true)
            } else {
                setLoading(false)
                setMfaData(data.objeto)
                setModal2fa(true)
            }
        } catch (error) {
            setLoading(false)
            setError("Error en el backend. Intenta nuevamente.")
            setModalError(true)
        }
    }

    return (
        <>
            {modalSuccess && (
                <Modal show={modalSuccess} onHide={()=>setModalSuccess(false)} animation={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>¡Segundo factor de autenticación activado!</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Tienes doble protección para tus proyectos.</Modal.Body>
                </Modal>
            )}
            {modalError && (
                <Modal show={modalError} onHide={()=>setModalError(false)} animation={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>¡Ha ocurrido un problema!</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{error}</Modal.Body>
                </Modal>
            )}
            {modal2fa && (
                <Modal2FAPerfil 
                    show={modal2fa}
                    onClose={() => setModal2fa(false)}
                    mfaTokenData={mfaData}
                    onSuccess={() => { 
                        setLoading(false)
                        setModal2fa(false); 
                        setModalSuccess(true)
                    }}
                    onError={(mensaje) => {
                        setLoading(false)
                        setError(mensaje)
                        setModalError(true)
                    }}
                />
            )}
            {/* Loading */}
            {loading && <div className='loading position-fixed top-0 start-0 vh-100 vw-100 z-3 d-flex flex-column align-items-center justify-content-center'>
                <Oval
                    visible={true}
                    height="80"
                    width="80"
                    color="#fff"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                />
                <p className='text-white fw-medium'>Loading...</p>
            </div>}
            <div className='profile d-flex flex-column align-items-center'>
                <div className='d-flex flex-column align-items-center mb-4'>
                    <img className='rounded-circle mb-2' src={Avatar} alt='Avatar' />
                    <h3 className='mb-4 text-blue-500'>{user.nombre}</h3>
                    <h4 className='mb-1 fw-medium text-blue-500'>Correo</h4>
                    <p className='mb-3'>{user.mail}</p>
                    <h4 className='mb-1 fw-medium text-blue-500'>Puesto</h4>
                    <p className='mb-3'>
                        {user.puesto === 1 && "Admin"}
                        {user.puesto === 2 && "Consultora"}
                        {user.puesto === 3 && "Gerente"}
                        {user.puesto === 4 && "Jefe de Área"}
                        {user.puesto === 5 && "Empleado"}
                        {user.puesto === 6 && "Aprobador de Muestras"}
                        {user.puesto === 7 && "Auditor Externo"}
                    </p>
                    {areaSelected && (
                        <>
                            <h4 className='mb-1 fw-medium text-blue-500'>Área</h4>
                            <p className='mb-3'>{areaSelected.nombre_del_Area}</p>
                        </>
                    )}
                    {user?.mfa_activo === 0 && <button onClick={showModal} className='btn btn-primary rounded-pill fw-medium px-4'>Activa doble factor</button>}
                    {user?.mfa_activo === 1 && (
                        <>
                            <h4 className='mb-1 fw-medium text-blue-500'>Protección doble factor</h4>
                            <p className='mb-3'>Activado</p>
                        </>
                    )}
                </div>    
            </div>
        </>
    )
}

export default Perfil